var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon 24x24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_b_2879_11315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.53333C14.2327 8.53333 12.8 9.96602 12.8 11.7333V12.8H19.2V11.7333C19.2 9.96602 17.7673 8.53333 16 8.53333Z",
    fill: "url(#paint0_linear_2879_11315)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8365 32 16 32C7.16344 32 -5.4282e-06 24.8365 0 16C0 7.16344 7.16344 -5.42819e-06 16 0ZM10.6667 11.7333V12.9821C9.42379 13.4214 8.53333 14.6067 8.53333 16V22.4C8.53333 24.1673 9.96602 25.6 11.7333 25.6H20.2667C22.034 25.6 23.4667 24.1673 23.4667 22.4V16C23.4667 14.6067 22.5762 13.4214 21.3333 12.9821V11.7333C21.3333 8.78782 18.9455 6.4 16 6.4C13.0545 6.4 10.6667 8.78782 10.6667 11.7333Z",
    fill: "url(#paint1_linear_2879_11315)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6665 12.9825V11.7337C10.6665 8.78821 13.0544 6.40039 15.9999 6.40039C18.9454 6.40039 21.3332 8.78821 21.3332 11.7337V12.9825C22.5761 13.4218 23.4665 14.6071 23.4665 16.0004V22.4004C23.4665 24.1677 22.0338 25.6004 20.2665 25.6004H11.7332C9.96589 25.6004 8.5332 24.1677 8.5332 22.4004V16.0004C8.5332 14.6071 9.42366 13.4218 10.6665 12.9825ZM12.7999 11.7337C12.7999 9.96641 14.2326 8.53372 15.9999 8.53372C17.7672 8.53372 19.1999 9.96641 19.1999 11.7337V12.8004H12.7999V11.7337Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2879_11315",
    x: -11.3353,
    y: -11.3353,
    width: 54.6706,
    height: 54.6706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.66764
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2879_11315"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2879_11315",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2879_11315",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232323",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2879_11315",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232323",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323",
    stopOpacity: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedIcon);
export default __webpack_public_path__ + "static/media/blocked-icon.4d9076ec81da3097d4a4dc3294ea17b5.svg";
export { ForwardRef as ReactComponent };